import { Site, formatNumber } from '@debbie/common/dist/index.js';
import { TenantType } from '@debbie/common/dist/tenants/index.js';
import { useCaseGroups } from '@debbie/cortex/dist/case-groups/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useCaseFilter } from '@debbie/cortex/dist/insights/caseFilter.js';
import * as caseFilterStore from '@debbie/cortex/dist/insights/caseFilter.js';
import { useCaseFilterCount } from '@debbie/cortex/dist/insights/index.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import Button from '../Button.js';
import CreditorSelector from '../CreditorSelector.js';
import Modal from '../Modal.js';
import AdvancedFilter from './AdvancedFilter.js';
import CaseFilterBadges from './CaseFilterBadges.js';
import CaseFilterQueue from './CaseFilterQueue.js';
const Filter = (props) => {
    const [filterModalOpen, setFilterModalOpen] = useState(false);
    const tenant = useTenant();
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const caseFilter = useCaseFilter();
    const caseFilterCountLoadable = useCaseFilterCount(caseFilter);
    const caseFilterCount = h.hasData(caseFilterCountLoadable)
        ? caseFilterCountLoadable.data.count
        : null;
    const toggleFilterModal = () => setFilterModalOpen(!filterModalOpen);
    return (React.createElement(StyledFilter, null,
        React.createElement("div", null,
            tenant?.type === TenantType.AccountsReceivable ? (React.createElement(CaseGroupSelector, null)) : (React.createElement(CreditorSelector, { style: {
                    width: '100%',
                    marginRight: '5px',
                }, onChange: props.onChange })),
            site == Site.Caseworker && (React.createElement(Button, { theme: "secondary", size: "small", onClick: toggleFilterModal }, lang.caseFilter.moreFilters)),
            filterModalOpen && (React.createElement(Modal, { onToggle: toggleFilterModal, header: lang.caseFilter.advancedFilters },
                React.createElement(AdvancedFilter, null)))),
        React.createElement("p", null,
            React.createElement("b", null, caseFilterCount
                ? formatNumber(caseFilterCount * 100).slice(0, -3)
                : '-'),
            ' ',
            lang.caseFilter.casesSelected,
            " ",
            React.createElement(CaseFilterQueue, null),
            " ",
            React.createElement(CaseFilterBadges, null))));
};
export default Filter;
const StyledFilter = styled.div `
  & > div {
    margin-bottom: ${THEME.GRID_SPACING}px;
    display: flex;
    justify-content: space-between;
  }

  & > p {
    margin: -1em 0 0 0;
    font-size: 0.8em;
  }
`;
const CaseGroupSelector = () => {
    const lang = useSelector((s) => s.lang);
    const caseFilter = useCaseFilter();
    const caseGroupsLoadable = useCaseGroups();
    const caseGroups = h.hasData(caseGroupsLoadable)
        ? caseGroupsLoadable.data
        : null;
    return (React.createElement("div", { style: {
            width: '100%',
            marginRight: '5px',
        } },
        React.createElement(Select, { value: (caseFilter.caseGroups || []).map((caseGroupId) => {
                const caseGroup = caseGroups && caseGroups.find((cG) => cG.id === caseGroupId);
                return {
                    label: (caseGroup && caseGroup.label) || caseGroupId,
                    value: caseGroupId,
                };
            }), isMulti: true, placeholder: lang.caseFilter.selectCaseGroup, classNamePrefix: "select", options: (caseGroups || []).map((caseGroup) => ({
                label: caseGroup.label,
                value: caseGroup.id,
            })), onChange: (val) => {
                const selected = val ? val.map((v) => v.value) : [];
                caseFilterStore.updateFilter({
                    caseGroups: selected,
                });
            } })));
};
//# sourceMappingURL=Filter.js.map